const COLLECTION_BG_VARS = {
  White: 'var(--white)',
  Black: 'var(--black)',
  'Sandy beige': 'var(--sandy-beige)',
  'Stone blue': 'var(--stone-blue)',
  'Vass green': 'var(--vass-green)',
  'Deep blue': 'var(--deep-blue)',
  'Ginst yellow': 'var(--ginst-yellow)',
  'Ocean blue': 'var(--ocean-blue)',
};

const COLLECTION_BG_CLASSES = {
  White: 'bg-white',
  Black: 'bg-black',
  'Sandy beige': 'bg-sandy-beige',
  'Stone blue': 'bg-stone-blue',
  'Vass green': 'bg-vass-green',
  'Deep blue': 'bg-deep-blue',
  'Ginst yellow': 'bg-ginst-yellow',
  'Ocean blue': 'bg-ocean-blue',
};

const DARK_COLLECTION_BG_KEYS = new Set(['Deep blue', 'Black']);

const COLLECTION_BG_ALIASES = {
  'Ocean Blue': 'Ocean blue',
  'bg-color': 'Stone blue',
  green: 'Stone blue',
  'dark-green': 'Stone blue',
  'light-green': 'Stone blue',
};

function normalizeCollectionBackgroundKey(value) {
  if (!value) {
    return null;
  }

  const trimmed = String(value).trim();
  const key = COLLECTION_BG_ALIASES[trimmed] || trimmed;

  return COLLECTION_BG_VARS[key] ? key : null;
}

export function hasCollectionBackground(value) {
  return normalizeCollectionBackgroundKey(value) !== null;
}

export function getCollectionBackgroundColor(value) {
  const key = normalizeCollectionBackgroundKey(value);

  return key ? COLLECTION_BG_VARS[key] : null;
}

export function getCollectionListItemStyle(value) {
  const key = normalizeCollectionBackgroundKey(value);

  if (!key) {
    return undefined;
  }

  return {
    '--collection-item-bg': COLLECTION_BG_VARS[key],
    '--collection-item-fg': DARK_COLLECTION_BG_KEYS.has(key) ? 'var(--white)' : 'var(--deep-blue)',
  };
}

export function getCollectionItemBackgroundStyle(parentVariant, itemVariant) {
  if (hasCollectionBackground(itemVariant)) {
    return getCollectionListItemStyle(itemVariant);
  }

  return undefined;
}

export function getSectionHeaderBackgroundStyle(value) {
  return getCollectionListItemStyle(value);
}

export function getCollectionBackgroundClassName(value) {
  const key = normalizeCollectionBackgroundKey(value);

  return key ? COLLECTION_BG_CLASSES[key] : '';
}

export function getCollectionLinkTitleStyle(bgValue, fontValue) {
  const bg = getCollectionBackgroundColor(bgValue);
  const font = getCollectionBackgroundColor(fontValue);

  if (!bg && !font) {
    return undefined;
  }

  return {
    '--collection-link-bg': bg || 'var(--stone-blue)',
    '--collection-link-color': font || 'var(--black)',
  };
}
